/*
 * Core charge handling (Nationwide Differential)
 * 1. Product page: when a product has a core charge, "Add to cart" adds the unit AND its Core Charge
 *    line in one request. "Pay later" puts the core on the Downpay purchase option ($0 today).
 * 2. Cart: keeps core lines in step with their units. Removing a unit removes its core, changing the
 *    unit quantity changes the core quantity, and a removed core is put back while its unit is in the cart.
 */
(function () {
  if (window.__coreChargeLoaded) return;
  window.__coreChargeLoaded = true;

  var SOURCE = 'core-charge';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function findCoreBox(form) {
    var scope = form.closest('product-info') || form.closest('.shopify-section') || document;
    return scope.querySelector('[data-core-charge]');
  }

  // ---------- 1. Add to cart with core ----------
  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var productForm = form.closest('product-form');
      if (!productForm) return;
      var box = findCoreBox(form);
      if (!box) {
        // Quick "Add to cart" on a product card (collection/search grids) has no core choice.
        // Send the shopper to the product page so they pick how to pay the core.
        var card = form.closest('.card-wrapper, .card');
        var link = card && card.querySelector('a[href*="/products/"]');
        if (link) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
          window.location.href = link.href;
        }
        return;
      }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.stopPropagation();
      addWithCore(productForm, form, box);
    },
    true
  );

  function setLoading(productForm, on) {
    var btn = productForm.querySelector('[type="submit"]');
    var spinner = productForm.querySelector('.loading__spinner');
    if (!btn) return;
    if (on) {
      btn.setAttribute('aria-disabled', true);
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function showError(productForm, message) {
    if (typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(message);
    } else if (message) {
      alert(message);
    }
  }

  function addWithCore(productForm, form, box) {
    var btn = productForm.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();

    var choice = box.querySelector('input[type="radio"]:checked');
    var plan = box.dataset.corePlan;
    var later = !!(choice && choice.value === 'later' && plan);
    var src = new FormData(form);
    var mainId = src.get('id');
    var qty = parseInt(src.get('quantity'), 10) || 1;

    var fd = new FormData();
    fd.append('items[0][id]', mainId);
    fd.append('items[0][quantity]', qty);
    src.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) fd.append('items[0][properties][' + m[1] + ']', val);
      if (key === 'selling_plan' && val) fd.append('items[0][selling_plan]', val);
    });
    fd.append('items[0][properties][_core_variant]', box.dataset.coreVariant);
    fd.append('items[0][properties][_core_plan]', later ? plan : 'now');

    fd.append('items[1][id]', box.dataset.coreVariant);
    fd.append('items[1][quantity]', qty);
    if (later) fd.append('items[1][selling_plan]', plan);
    fd.append('items[1][properties][Core for]', box.dataset.productTitle);
    fd.append('items[1][properties][_core_for]', mainId);

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    setLoading(productForm, true);
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          showError(productForm, res.description || res.message);
          return;
        }
        var main = (res.items && res.items[0]) || {};
        var parsed = Object.assign({}, main, { sections: res.sections });

        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || root() + 'cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, productVariantId: mainId, cartData: parsed });
        }
        var modal = productForm.closest('quick-add-modal');
        if (modal) {
          document.body.addEventListener(
            'modalClosed',
            function () {
              setTimeout(function () {
                cart.renderContents(parsed);
              });
            },
            { once: true }
          );
          modal.hide(true);
        } else {
          cart.renderContents(parsed);
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      })
      .catch(function (e) {
        console.error(e);
        showError(productForm, 'Something went wrong adding this to your cart. Please try again.');
      })
      .finally(function () {
        setLoading(productForm, false);
      });
  }

  // ---------- 2. Keep core lines in step with their units ----------
  var busy = false;

  function planOf(item) {
    return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? String(item.selling_plan_allocation.selling_plan.id)
      : 'now';
  }

  function recentlyReloaded() {
    try {
      var t = parseInt(sessionStorage.getItem('coreChargeReload') || '0', 10);
      return Date.now() - t < 8000;
    } catch (e) {
      return false;
    }
  }

  function markReload() {
    try {
      sessionStorage.setItem('coreChargeReload', String(Date.now()));
    } catch (e) {}
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var want = {};
        var have = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._core_variant) {
            var k = p._core_variant + '|' + (p._core_plan || 'now') + '|' + it.variant_id;
            if (!want[k]) want[k] = { qty: 0, title: it.product_title, core: p._core_variant, plan: p._core_plan || 'now', forId: it.variant_id };
            want[k].qty += it.quantity;
          } else if (p._core_for) {
            var c = it.variant_id + '|' + planOf(it) + '|' + p._core_for;
            if (!have[c]) have[c] = [];
            have[c].push(it);
          }
        });

        var updates = {};
        var changed = false;
        Object.keys(have).forEach(function (k) {
          var lines = have[k];
          var target = want[k] ? want[k].qty : 0;
          lines.forEach(function (line, i) {
            var q = i === 0 ? target : 0;
            if (line.quantity !== q) {
              updates[line.key] = q;
              changed = true;
            }
          });
        });

        var adds = [];
        Object.keys(want).forEach(function (k) {
          if (have[k]) return;
          var w = want[k];
          var item = { id: Number(w.core), quantity: w.qty, properties: { 'Core for': w.title, _core_for: String(w.forId) } };
          if (w.plan !== 'now') item.selling_plan = Number(w.plan);
          adds.push(item);
        });

        if (!changed && !adds.length) return false;
        if (recentlyReloaded()) return false; // safety: never loop

        var jobs = [];
        if (changed) {
          jobs.push(
            fetch(root() + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates }),
            })
          );
        }
        if (adds.length) {
          jobs.push(
            fetch(root() + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: adds }),
            })
          );
        }
        return Promise.all(jobs).then(function () {
          return true;
        });
      })
      .then(function (didChange) {
        if (didChange) {
          markReload();
          window.location.reload();
        }
      })
      .catch(function (e) {
        console.error('core-charge', e);
      })
      .finally(function () {
        busy = false;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    reconcile();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SOURCE) return;
        setTimeout(reconcile, 300);
      });
    }
  });
})();
